module.exports = __webpack_public_path__ + "static/media/fond-nuages-1920-2.65dfc84a.png";